import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/imgs/cookie-icon.png")